import { ArrayUtils } from '@colonist/utils';
export function diffDataObjects(originalData, newData) {
    const diff = {};
    for (const key of Object.keys(originalData)){
        const doesNewDataHaveAttribute = key in newData;
        if (doesNewDataHaveAttribute) continue;
        diff[key] = null;
    }
    for (const key of Object.keys(newData)){
        const newValue = newData[key];
        const doesAttributeExist = key in originalData;
        const originalValue = doesAttributeExist ? originalData[key] : createEmptyDataOfType(newValue);
        if (originalValue === null) throw new Error(`Original attribute cannot be set to null. Null is reserved for deleting properties.`);
        if (Array.isArray(originalValue) || Array.isArray(newValue)) {
            const isNewArrayEmpty = Array.isArray(newValue) && newValue.length === 0;
            if (isNewArrayEmpty && !doesAttributeExist) {
                diff[key] = [];
                continue;
            }
            const arrayDiff = diffSimpleArrays(originalValue, newValue);
            if (arrayDiff == undefined) continue;
            diff[key] = arrayDiff;
            continue;
        }
        if (newValue === null) {
            if (typeof originalValue != 'object') throw new Error(`Null can only used with object attributes. Consider using Undefined instead. Null is a reserved for deleting properties`);
            diff[key] = null;
            continue;
        }
        if (typeof newValue == 'object' && typeof originalValue == 'object') {
            const isNewValueEmpty = Object.keys(newValue).length === 0;
            if (isNewValueEmpty && !doesAttributeExist) {
                diff[key] = {};
                continue;
            }
            const nestedDiff = diffDataObjects(originalValue, newValue);
            if (nestedDiff == undefined) continue;
            diff[key] = nestedDiff;
            continue;
        }
        if (typeof newValue == 'object' || typeof originalValue == 'object') throw new Error('Objects did not have the same nested structure');
        if (originalValue === newValue) continue;
        diff[key] = newValue;
    }
    const isEmptyDiff = Object.keys(diff).length === 0;
    if (isEmptyDiff) return undefined;
    return diff;
}
export function createEmptyDataOfType(newValue) {
    if (Array.isArray(newValue)) return [];
    if (typeof newValue == 'object') return {};
    return undefined;
}
export function diffSimpleArrays(originalData, newData) {
    const errorDataNotArray = `Can only compare simple arrays if both objects are arrays`;
    if (!Array.isArray(originalData) || !Array.isArray(newData)) throw new Error(errorDataNotArray);
    const errorNotSimpleArray = `Only simple string and number arrays can be used in this system. Please convert array to indexed object instead.`;
    if (!isSimpleArray(originalData)) throw new Error(errorNotSimpleArray);
    if (!isSimpleArray(newData)) throw new Error(errorNotSimpleArray);
    if (ArrayUtils.arraysEqual(originalData, newData)) return undefined;
    return [
        ...newData
    ];
}
export function isSimpleArray(array) {
    const validTypes = [
        'undefined',
        'number',
        'string'
    ];
    for (const element of array){
        if (!validTypes.includes(typeof element)) return false;
    }
    return true;
}
export function deleteNullValues(data) {
    for(const key in data){
        const value = data[key];
        if (value === null) {
            delete data[key];
            continue;
        }
        if (Array.isArray(value)) continue;
        if (typeof value === 'object') deleteNullValues(value);
    }
}
export function squashDiffs(diffs) {
    const squashedDiff = {};
    for (const diff of diffs){
        squashDiff(squashedDiff, diff);
    }
    return squashedDiff;
}
function squashDiff(squashedDiff, diff) {
    for (const key of Object.keys(diff)){
        const value = diff[key];
        if (value === null) {
            squashedDiff[key] = null;
            continue;
        }
        if (Array.isArray(value)) {
            squashedDiff[key] = value;
            continue;
        }
        if (typeof value == 'object') {
            if (!(key in squashedDiff)) squashedDiff[key] = {};
            squashDiff(squashedDiff[key], value);
            continue;
        }
        squashedDiff[key] = value;
    }
}
export function applyDiffs(originalData, diffs) {
    for (const diff of diffs){
        applyDiff(originalData, diff);
    }
}
function applyDiff(originalData, diff) {
    for (const key of Object.keys(diff)){
        const value = diff[key];
        if (value === null) {
            delete originalData[key];
            continue;
        }
        if (Array.isArray(value)) {
            originalData[key] = value;
            continue;
        }
        if (typeof value == 'object') {
            if (!(key in originalData)) originalData[key] = {};
            applyDiff(originalData[key], value);
            continue;
        }
        originalData[key] = value;
    }
}
